import { i18n, t } from '@ezbobdev/ui-framework';

export { default as classnames } from 'classnames';

export const interpolateString = (obj) => {
  const { linkTo, params } = obj;

  if (params) {
    return linkTo.replace(/:(\w+)/g, (match, key) => {
      return Object.prototype.hasOwnProperty.call(params, key) ? params[key] : match;
    });
  }

  return linkTo;
};

export const getColor = (theme, color) => {
  const arr = color.split('.');
  let result = theme.palette;
  arr.forEach((el) => {
    result = result[el];
  });

  return result;
};
